import { render, staticRenderFns } from "./course-list-item.vue?vue&type=template&id=19ddee09&scoped=true"
import script from "./course-list-item.vue?vue&type=script&lang=js"
export * from "./course-list-item.vue?vue&type=script&lang=js"
import style0 from "./course-list-item.vue?vue&type=style&index=0&id=19ddee09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ddee09",
  null
  
)

export default component.exports